/**
 * CDN DIT URL'lerinden responsive srcset üretir.
 * Manşet teslimatı: mobil ≤400, masaüstü ≤960 (1260 yok).
 */
import { DELIVERY_QUALITY_CAP } from './image-presets'

const DIT_RE =
  /^(https?:\/\/[^/]+)\/(\d+)x(\d+)\/(\d+)\/(cover|inside)\/(.+)$/i

export function rewriteDitUrl(
  url: string,
  width: number,
  height: number,
  quality: number,
): string {
  const m = String(url || '').match(DIT_RE)
  if (!m) return url
  const [, origin, , , , fit, rest] = m
  return `${origin}/${width}x${height}/${quality}/${fit}/${rest}`
}

/** Mobil manşet srcset */
export function mastheadMobileSrcSet(url: string): string | undefined {
  if (!DIT_RE.test(url)) return undefined
  const q = DELIVERY_QUALITY_CAP
  return [
    `${rewriteDitUrl(url, 320, 200, q)} 320w`,
    `${rewriteDitUrl(url, 400, 224, q)} 400w`,
  ].join(', ')
}

/** Masaüstü manşet — orta kutu ~660px; max 960 */
export function mastheadDesktopSrcSet(url: string): string | undefined {
  if (!DIT_RE.test(url)) return undefined
  const q = DELIVERY_QUALITY_CAP
  return [
    `${rewriteDitUrl(url, 720, 400, q)} 720w`,
    `${rewriteDitUrl(url, 960, 533, q)} 960w`,
  ].join(', ')
}

/** @deprecated — picture source'ları tercih et */
export function mastheadSrcSet(url: string): string | undefined {
  const mobile = mastheadMobileSrcSet(url)
  const desktop = mastheadDesktopSrcSet(url)
  if (!mobile || !desktop) return mobile || desktop
  return `${mobile}, ${desktop}`
}

/** Fallback src — mobil ağırlıklı 400 */
export function mastheadDefaultSrc(url: string): string {
  return rewriteDitUrl(url, 400, 224, DELIVERY_QUALITY_CAP)
}
